import { ArrowRight, Layout, Palette, TrendingUp, Video } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, SectionHeader, TopoLines, scrollToTarget } from "./ui-bits";

const ICONS = { Palette, Layout, Video, TrendingUp };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative scroll-mt-20 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeader
          index="07"
          station="Services"
          id="LOGISTICS // EXPEDITION PACKAGES"
          title={<>Services<br /><span className="text-ember">What I Offer</span></>}
          sub="Four routes I can run for your brand — from first sketch to live summit push. Every package is planned around one thing: your brief."
        />

        <div className="grid gap-6 md:grid-cols-2 lg:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={0.08 + i * 0.08} className="h-full">
                <article
                  data-testid={`service-card-${i + 1}`}
                  className="group relative flex h-full flex-col overflow-hidden border border-white/10 bg-ink/70 p-6 transition-colors duration-300 hover:border-ember/60 md:p-8"
                >
                  <TopoLines className="pointer-events-none absolute inset-0 h-full w-full" />
                  <div className="relative flex items-center justify-between">
                    <span className="border border-ember/40 bg-ember/10 px-2 py-1 font-mono text-[9px] font-bold tracking-[0.25em] text-ember">
                      {s.code}
                    </span>
                    <Icon className="h-5 w-5 text-ember transition-transform duration-300 group-hover:scale-110" strokeWidth={1.75} />
                  </div>
                  <h3 className="relative mt-6 font-display text-xl font-black uppercase tracking-wide text-cream transition-colors duration-300 group-hover:text-ember md:text-2xl">
                    {s.title}
                  </h3>
                  <p className="relative mt-3 text-sm leading-relaxed text-slate-300 md:text-base">{s.description}</p>
                  <div className="relative mt-5 flex flex-wrap gap-2 pb-6">
                    {s.skills.map((sk) => (
                      <span key={sk} className="border border-white/10 px-2.5 py-1 font-mono text-[9px] tracking-[0.15em] text-slate-400">
                        {sk.toUpperCase()}
                      </span>
                    ))}
                  </div>
                  <button
                    onClick={() => scrollToTarget("#contact")}
                    data-testid={`service-cta-${i + 1}`}
                    className="btn-fill relative mt-auto flex items-center justify-between gap-3 px-5 py-3 font-mono text-[10px] font-bold tracking-[0.22em]"
                  >
                    PLAN THIS ROUTE <ArrowRight className="h-4 w-4" />
                  </button>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="relative mt-8 overflow-hidden border border-white/10 bg-ink/70 md:mt-10" data-testid="services-cta-band">
            <TopoLines className="pointer-events-none absolute inset-0 h-full w-full" />
            <div className="relative flex flex-col items-start justify-between gap-6 p-6 md:flex-row md:items-center md:p-8">
              <div>
                <p className="font-mono text-[9px] tracking-[0.3em] text-ember md:text-[10px]">BASE CAMP IS OPEN</p>
                <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight text-white md:text-3xl">
                  Have an expedition <span className="text-ember">in mind?</span>
                </h3>
                <p className="mt-2 text-sm text-slate-400 md:text-base">Send a dispatch — tell me the brief, and I&rsquo;ll plan the route.</p>
              </div>
              <button
                onClick={() => scrollToTarget("#contact")}
                data-testid="services-final-cta"
                className="btn-fill flex shrink-0 items-center gap-3 px-7 py-4 font-mono text-[11px] font-bold tracking-[0.22em]"
              >
                START AN EXPEDITION <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
